export default {
    get: key => localStorage.getItem(key),
    set: (key, val) => localStorage.setItem(key, val),
    remove: key => localStorage.removeItem(key)
};



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/helpers/localStorage.js